var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.5 11.134C19.1667 11.5189 19.1667 12.4811 18.5 12.866L9.5 18.0622C8.83333 18.4471 8 17.966 8 17.1962L8 6.80385C8 6.03405 8.83333 5.55292 9.5 5.93782L18.5 11.134Z","fill":"white"}));
}

PlayIcon.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
